import { formatDayMonth, formatTime } from '../../utils/formatDate';

const sameDay = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

/** Today's messages show the time, older ones the day and month. */
export function formatListTime(iso: string, now: Date = new Date()): string {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return sameDay(d, now) ? formatTime(d, '') : formatDayMonth(d, '');
}

export function sameCalendarDay(aIso: string, bIso: string): boolean {
  return sameDay(new Date(aIso), new Date(bIso));
}

export function initialsOf(label: string): string {
  const parts = label.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0][0] ?? '';
  const second = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + second).toUpperCase();
}
